export const aciSearch = {
    iconName: 'search',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 25 25' },
        path: [
            {
                attr: {
                    'clip-rule': 'evenodd',
                    d: 'M14.54 18.803A8.056 8.056 0 108.238 3.974a8.056 8.056 0 006.302 14.829z',
                    stroke: 'currentColor',
                    'stroke-width': '1.5',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M17.085 17.084l6.248 6.25',
                    stroke: 'currentColor',
                    'stroke-width': '1.5',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
        ],
    },
};
